import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
    Box,
    Container,
    Typography,
    Grid,
    Button,
    MenuItem,
    InputAdornment,
    InputBase,
    IconButton,
    CircularProgress,
    Select,
    FormControl,
    FormHelperText,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContentWrapper from "../../../../common/components/contentWrapper";
import EditIcon from "@material-ui/icons/Edit";
import "../../dashboard/style/createInventory.css";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
    addInventoryData,
    addMiscInventoryData,
    individualBrowseWatch,
    searchProducts,
    searchLocation,
} from "../../dealer/actions/dealerAction";
import searchinventry, { createRequest } from "../actions/dashboardaapi";
import { getBusinessAccountIds } from "../actions/dashboardAction";
import { brandList, caseMaterial, brandMaterial } from "../../browse-watches/actions/browseWatchesActions";
import { Popover as AntdPopover, Input as AntdInput } from "antd";
import ClearIcon from "@material-ui/icons/Clear";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

const GOLD = '#CEA05F';

const WATCH_REQUEST_LIST_ROUTE = "/watch-request-list";

const CASE_MATERIALS = ['Stainless Steel', 'Gold', 'Rose Gold', 'Platinum', 'Titanium', 'Ceramic', 'Other'];
const BAND_MATERIALS = ['Stainless Steel', 'Leather', 'Rubber', 'Nylon', 'Gold', 'Titanium', 'Other'];

const INITIAL_FORM = {
    watchType: 'standard',
    selectedWatch: null,
    inventoryTitle: '',
    brand: '',
    modelName: '',
    modelNumber: '',
    caseMaterial: '',
    caseSize: '',
    dialColor: '',
    bandMaterial: '',
    bandSize: '',
    numberOfLinks: '',
    description: '',
    requestFrom: '',
    requestFromContactId: null,
    preferredBudget: '',
    preferredBudgetMax: '',
    requestNotes: '',
    requestedOn: null,
    targetDate: null,
};

const labelStyle = {
    display: "inline-block",
    width: "160px",
    fontWeight: "bold",
    verticalAlign: "top",
};
const valueStyle = {
    display: "inline-block",
    width: "calc(100% - 168px)",
    verticalAlign: "top",
    wordBreak: "break-word",
};

const formatCurrency = (value) => {
    if (value === null || value === undefined) return "";
    return Number(value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const isValidDate = (date) => date instanceof Date && !isNaN(date);

const parseMDY = (str) => {
    if (!str) return null;
    const [m, d, y] = str.split('/');
    if (!m || !d || !y) return null;
    return new Date(+y, +m - 1, +d);
};
const startOfToday = () => {
    const t = new Date();
    return new Date(t.getFullYear(), t.getMonth(), t.getDate());
};

const PRICE_RANGE_ERROR = 'Target Min Price must be less than or equal to Target Max Price.';
const getPriceRangeError = (min, max) =>
    min !== '' && max !== '' && Number(min) > Number(max) ? PRICE_RANGE_ERROR : undefined;

const REQUEST_FROM_TYPES = ["supplier", "memo_supplier"];

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const destructureData = (data) => {
    const groupedByEmail = {};
    data.forEach((value) => {
        const Email = value.email;
        groupedByEmail[Email] = groupedByEmail[Email] || [];
        groupedByEmail[Email].push(value);
    });
    return Object.values(groupedByEmail);
};

const handleContact = (val) =>
    [
        [val?.firstname, val?.lastname].filter(Boolean).join(" "),
        val?.businessname,
        val?.billingaddress1,
        val?.billingaddress2,
        val?.billingcity,
        val?.billingstate,
        val?.billingcountry,
        val?.billingzipcode,
    ]
        .filter(Boolean)
        .join(", ");

const FieldLabel = ({ children, required }) => (
    <Typography
        component="div"
        style={{ fontWeight: 450, color: '#000', marginBottom: '5px' }}
    >
        {children}
        {required && <span className="ai-field-label__required"> *</span>}
    </Typography>
);

const ErrorText = ({ children }) =>
    children ? (
        <FormHelperText
            error
            className="error-o"
            sx={{ color: 'red !important', fontSize: 12, mt: 0.5, mx: 0 }}
        >
            {children}
        </FormHelperText>
    ) : null;

const SectionCard = ({ icon, title, right, children }) => (
    <div className="ai-section-card">
        <div className="ai-section-card__header">
            <span className="ai-section-card__icon">{icon}</span>
            <span className="ai-section-card__title">{title}</span>
            {right && <span style={{ marginLeft: 'auto' }}>{right}</span>}
        </div>
        {children}
    </div>
);

const getTodayString = () => {
    const d = new Date();
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
};

const UploadZone = ({ accept, hint, icon, files, onAdd, onRemove, multiple = true }) => {
    const inputRef = useRef(null);

    const handleFiles = (fileList) => {
        const picked = Array.from(fileList || []);
        if (picked.length) onAdd(picked);
    };

    return (
        <div>
            <div
                className="ai-dropzone"
                onClick={() => inputRef.current && inputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                    e.preventDefault();
                    handleFiles(e.dataTransfer.files);
                }}
            >
                <div className="ai-dropzone__icon">{icon}</div>
                <Typography className="ai-dropzone__title">Click to upload or drag &amp; drop</Typography>
                <Typography className="ai-dropzone__hint">{hint}</Typography>
                <input
                    ref={inputRef}
                    type="file"
                    hidden
                    multiple={multiple}
                    accept={accept}
                    onChange={(e) => {
                        handleFiles(e.target.files);
                        e.target.value = '';
                    }}
                />
            </div>

            {files.length > 0 && (
                <div className="ai-uploads__filelist">
                    {files.map((f, idx) => (
                        <div className="ai-uploads__file-chip" key={`${f.name}-${idx}`}>
                            <div className="ai-uploads__file-chip-info">
                                <Typography className="ai-uploads__file-chip-name">{f.name}</Typography>
                                <Typography className="ai-uploads__file-chip-size">
                                    {(f.size / 1024).toFixed(1)} KB
                                </Typography>
                            </div>
                            <IconButton size="small" onClick={() => onRemove(idx)}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const WatchRequestPage = (props) => {
    const { onCancel, onSubmit } = props;

    const [form, setForm] = useState(() => ({ ...INITIAL_FORM, requestedOn: getTodayString() }));
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [InventoryType, setInventoryType] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [showResults, setShowResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [watchDetails, setWatchDetails] = useState(null); // IndividualBrowseWatchesData
    const [minmaxPricelist, setMinmaxPricelist] = useState(null);
    const [retailAmount, setRetailAmount] = useState('');
    const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
    const selectedIdRef = useRef(null);

    const [contactResults, setContactResults] = useState([]);
    const [contactGroups, setContactGroups] = useState([]);
    const [contactPopOver, setContactPopOver] = useState(false);
    const [contactLoading, setContactLoading] = useState(false);
    const accountIdsRef = useRef([]);
    const contactReqRef = useRef(0);
    const [materialOptions, setMaterialOptions] = useState({ caseMaterial: [], bandMaterial: [], brand: [] });
    const contactSearchRef = useRef(
        _.debounce((key, ids, cb) => {
            const payload = { key, type: REQUEST_FROM_TYPES, accountids: ids };
            searchinventry.getInventoryContactDetails(payload, (error, response) => {
                if (error) cb(null, error);
                else if (response?.data && response?.status == 1) cb(response.data, null);
                else cb([], null);
            });
        }, 1000)
    );
    const searchResults = (props.autocompleteProducts && props.autocompleteProducts.list) || [];

    const propsRef = useRef(props);
    useEffect(() => {
        propsRef.current = props;
    });

    const watchType =
        !InventoryType
            ? 'standard'
            : InventoryType === 'Misc Watch'
                ? 'misc_watch'
                : 'misc_product';

    const setField = (name) => (e) => {
        const value = e.target.value;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const handleDateField = (name) => (date, formatted) => {
        if (date === null || isValidDate(date)) {
            setForm((prev) => ({ ...prev, [name]: date === null ? null : formatted }));
            setErrors((prev) => ({ ...prev, [name]: undefined }));
        } else {
            setErrors((prev) => ({ ...prev, [name]: 'Invalid date' }));
        }
    };

    useEffect(() => {
        getBusinessAccountIds(window.sessionStorage.getItem("accountId"), (error, res) => {
            if (error) return;
            if (res?.data && res.success == 1) {
                accountIdsRef.current = res.data;
            }
        });
        const debounced = contactSearchRef.current;
        return () => debounced.cancel();
    }, []);

    const resetRequestFromResults = () => {
        setContactResults([]);
        setContactGroups([]);
        setContactLoading(false);
    };

    const toISODate = (str) => {
        if (!str) return null;
        const [m, d, y] = str.split("/");
        if (!m || !d || !y) return null;
        return new Date(Date.UTC(+y, +m - 1, +d)).toISOString().replace(".000Z", "Z");
    };

    const handleRequestFromChange = (e) => {
        const value = e.target.value;
        setForm((prev) => ({ ...prev, requestFrom: value, requestFromContactId: null }));
        if (errors.requestFrom) setErrors((prev) => ({ ...prev, requestFrom: undefined }));
        const reqId = ++contactReqRef.current;
        if (value && value.length > 2) {
            setContactLoading(true);
            contactSearchRef.current(value, accountIdsRef.current, (data, error) => {
                if (reqId !== contactReqRef.current) return; // ignore stale responses
                if (data && data.length > 0) {
                    setContactGroups(destructureData(data));
                    setContactResults(data);
                    setContactPopOver(true);
                } else {
                    setContactResults([]);
                    setContactGroups([]);
                }
                setContactLoading(false);
            });
        } else {
            contactSearchRef.current.cancel();
            resetRequestFromResults();
        }
    };

    const handleRequestFromSelect = (contact) => {
        const value = [
            contact?.businessname,
            contact?.firstname && contact?.lastname
                ? `${contact.firstname} ${contact.lastname}`
                : contact?.firstname || contact?.lastname,
        ]
            .filter(Boolean)
            .join(", ");
        contactReqRef.current += 1;
        setForm((prev) => ({ ...prev, requestFrom: value, requestFromContactId: contact?.contactid || null }));
        setContactPopOver(false);
        setErrors((prev) => ({ ...prev, requestFrom: undefined }));
    };

    const handleNumberField = (name) => (e) => {
        let cleaned = e.target.value.replace(/[^\d.]/g, '');
        const [whole, ...rest] = cleaned.split('.');
        cleaned = rest.length ? `${whole}.${rest.join('').slice(0, 2)}` : whole;
        setForm((prev) => ({ ...prev, [name]: cleaned }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const handlePriceField = (name) => (e) => {
        let cleaned = e.target.value.replace(/[^\d.]/g, '');
        const [whole, ...rest] = cleaned.split('.');
        cleaned = rest.length ? `${whole}.${rest.join('').slice(0, 2)}` : whole;
        const min = name === 'preferredBudget' ? cleaned : form.preferredBudget;
        const max = name === 'preferredBudgetMax' ? cleaned : form.preferredBudgetMax;
        setForm((prev) => ({ ...prev, [name]: cleaned }));
        setErrors((prev) => ({ ...prev, preferredBudgetMax: getPriceRangeError(min, max) }));
    };

    const formatWithCommas = (val) => {
        if (val === '' || val == null) return '';
        const [whole, dec] = String(val).split('.');
        const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return dec !== undefined ? `${withCommas}.${dec}` : withCommas;
    };

    const clearRequestFrom = () => {
        contactSearchRef.current.cancel();
        contactReqRef.current += 1;
        setForm((prev) => ({ ...prev, requestFrom: '', requestFromContactId: null }));
        resetRequestFromResults();
    };

    const clearWatchSelection = () => {
        selectedIdRef.current = null;
        setWatchDetails(null);
        setMinmaxPricelist(null);
        setRetailAmount('');
        setShowAdditionalDetails(false);
    };

    const resetSearch = () => {
        setSearchInput('');
        setShowResults(false);
        setSearchLoading(false);
        clearWatchSelection();
    };

    const handleWatchTypeChange = (e) => {
        setInventoryType(e.target.value);
        if (e.target.value) {
            props.brandList();
        }
        if (e.target.value === 'Misc Watch') {
            props.caseMaterial();
            props.brandMaterial();
        }
        setForm((prev) => ({
            ...INITIAL_FORM,
            requestFrom: prev.requestFrom,
            requestFromContactId: prev.requestFromContactId,
            preferredBudget: prev.preferredBudget,
            preferredBudgetMax: prev.preferredBudgetMax,
            requestNotes: prev.requestNotes,
            requestedOn: prev.requestedOn,
            targetDate: prev.targetDate,
            inventoryTitle: prev.selectedWatch ? '' : prev.inventoryTitle,
            bandSize: prev.bandSize,
            numberOfLinks: prev.numberOfLinks,
        }));
        resetSearch();
        setErrors({});
    };

    const getAutocompleteRef = useRef(
        _.debounce((text) => {
            const clean = text && text.replace(/[&\/\\#,+!@^&()$~%.'":;*?<>{}]/g, "");
            if (!clean || !clean.trim()) {
                setSearchLoading(false);
                return;
            }
            propsRef.current.searchProducts({ searchText: clean }, () => {
                setSearchLoading(false);
            });
        }, 500)
    );

    useEffect(() => {
        const debounced = getAutocompleteRef.current;
        return () => debounced.cancel();
    }, []);

    const handleSearchChange = (e) => {
        const text = e.target.value;
        setSearchInput(text);
        setShowResults(true);
        if (form.selectedWatch) {
            setForm((prev) => ({ ...prev, selectedWatch: null, inventoryTitle: '' }));
            clearWatchSelection();
        }
        if (errors.selectedWatch) setErrors((p) => ({ ...p, selectedWatch: undefined }));
        if (text.trim()) {
            setSearchLoading(true);
            getAutocompleteRef.current(text);
        } else {
            getAutocompleteRef.current.cancel();
            setSearchLoading(false);
        }
    };

    const getpriceListing = (id) => {
        searchinventry
            .getinventrypriceList(id)
            .then((res) => {
                if (selectedIdRef.current !== id) return;
                const list = (res && res.data && res.data.data) || [];
                const retail = list.find((item) => item.watch_source === 'Retail');
                setRetailAmount(retail ? retail.avg : '');
            })
            .catch(() => { });
    };

    useEffect(() => {
        const info = props.individualBrowseWatchesInfo;
        if (!info || !selectedIdRef.current) return;
        if (info.success === 0) {
            setErrors((p) => ({ ...p, selectedWatch: info.message }));
        } else {
            const d = info.data;
            if (d && d.productid) {
                setWatchDetails(d);
                setMinmaxPricelist(d.minmax_pricelist || null);
            }
        }
    }, [props.individualBrowseWatchesInfo]);

    const handleSelectWatch = (product) => {
        const pid = product.productid;
        const title = product.modelname || product.model || product.reference || '';
        selectedIdRef.current = pid;
        setShowResults(false);
        setSearchInput(title);
        setForm((prev) => ({
            ...prev,
            selectedWatch: product,
            inventoryTitle: title,
        }));
        setWatchDetails(product);
        setMinmaxPricelist(null);
        setRetailAmount('');
        if (errors.selectedWatch) setErrors((p) => ({ ...p, selectedWatch: undefined }));

        props.individualBrowseWatch(pid);
        getpriceListing(pid);
    };

    const handleClearWatch = () => {
        getAutocompleteRef.current.cancel();
        resetSearch();
        setForm((prev) => ({ ...prev, selectedWatch: null, inventoryTitle: '' }));
    };

    const validate = () => {
        const e = {};
        if (watchType === 'standard') {
            if (!form.selectedWatch) e.selectedWatch = 'Please select a watch';
        } else if (!form.modelName.trim()) {
            e.modelName = 'Model Name is required';
        }
        // if (images.length === 0) e.images = 'At least one reference image is required';
        if (!form.requestFrom.trim()) e.requestFrom = 'Request From is required';
        const reqOn = parseMDY(form.requestedOn);
          if (reqOn && reqOn > startOfToday()) e.requestedOn = 'Requested On date cannot be in the future.';
        const tgt = parseMDY(form.targetDate);
           if (tgt && tgt < startOfToday()) e.targetDate = 'Target Date cannot be in the past.';
        const priceErr = getPriceRangeError(form.preferredBudget, form.preferredBudgetMax);
        if (priceErr) e.preferredBudgetMax = priceErr;
        // if (!String(form.preferredBudget).trim()) e.preferredBudget = 'Target Price Min is required';
        // if (!String(form.preferredBudgetMax).trim()) e.preferredBudgetMax = 'Target Price Max is required';
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSave = () => {
        if (!validate()) return;

        const attr = (watchDetails && watchDetails.prodattr) || {};
        const isStandard = watchType === 'standard';
        const userDetails = JSON.parse(window.sessionStorage.getItem("userDetails") || "{}");
        const createdBy =
            (props.currentUser && props.currentUser.userId) ||
            userDetails.userId ||
            userDetails.userid ||
            "";
        const budgetMin = form.preferredBudget !== '' ? Number(form.preferredBudget) : null;
        const budgetMax = form.preferredBudgetMax !== '' ? Number(form.preferredBudgetMax) : null;

        const payload = {
            type: isStandard ? 'standard_watch' : watchType,
            inventory_type: InventoryType || 'Standard Watch',
            inventory_title: form.inventoryTitle,
            model_name: isStandard ? (attr.model || watchDetails?.model || '') : form.modelName,
            brand: isStandard ? (watchDetails?.brandname || '') : form.brand,
            model_number: isStandard ? (attr.reference || '') : form.modelNumber,
            description: form.description,
            case_material: isStandard ? (attr.casematerial || '') : form.caseMaterial,
            case_size: isStandard ? (attr.casesize || '') : form.caseSize,
            dial_color: isStandard ? (attr.dialcolor || '') : form.dialColor,
            band_material: isStandard ? (attr.bandmaterial || '') : form.bandMaterial,
            band_size: form.bandSize,
            number_of_links: form.numberOfLinks,
            request_notes: form.requestNotes,
            request_from_contact: form.requestFrom,
            request_contactid: form.requestFromContactId || null,
            requested_on: toISODate(form.requestedOn),
            target_date: toISODate(form.targetDate),
            target_price_min: budgetMin,
            target_price_max: budgetMax,
            status: "Open",
            accountid: window.sessionStorage.getItem("accountId"),
            productid: isStandard ? form.selectedWatch.productid : null,
            createdby: createdBy,
        };

        setSaving(true);
        searchinventry.createRequest(payload, (error, res) => {
            setSaving(false);
            if (error || res?.status !== 1) {
                toast(
                    error?.response?.data?.message || error?.message || res?.message || "Failed to create watch request",
                    {
                        autoClose: 2000,
                        type: toast.TYPE.ERROR,
                        position: toast.POSITION.BOTTOM_CENTER,
                    }
                );
                return;
            }
            toast("Watch request created successfully", {
                autoClose: 2000,
                type: toast.TYPE.SUCCESS,
                position: toast.POSITION.BOTTOM_CENTER,
            });
            if (onSubmit) onSubmit(res);
            if (props.history) props.history.push(WATCH_REQUEST_LIST_ROUTE);
        });
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        else if (props.history) props.history.goBack();
    };

    const fieldBlock = (label, node, required) => (
        <FormControl fullWidth className="ai-field">
            <FieldLabel required={required}>{label}</FieldLabel>
            {node}
        </FormControl>
    );

    const textField = (name, placeholder, extra = {}) => {
        const { multiline, large, ...rest } = extra;
        const cls = [
            'ai-input',
            multiline && 'ai-input--textarea',
            multiline && large && 'ai-input--textarea-lg',
        ]
            .filter(Boolean)
            .join(' ');
        return (
            <>
                <InputBase
                    fullWidth
                    className={cls}
                    placeholder={placeholder}
                    value={form[name]}
                    onChange={setField(name)}
                    error={Boolean(errors[name])}
                    multiline={Boolean(multiline)}
                    minRows={multiline ? (large ? 4 : 3) : undefined}
                    {...rest}
                />
                <ErrorText>{errors[name]}</ErrorText>
            </>
        );
    };

    const selectField = (name, options) => (
        <Select
            fullWidth
            displayEmpty
            variant="standard"
            disableUnderline
            className="ai-select"
            value={form[name]}
            onChange={setField(name)}
            renderValue={(v) => (v ? v : <span style={{ color: '#9e9e9e' }}>Select material</span>)}
        >
            {options.map((o) => (
                <MenuItem key={o} value={o}>
                    {o}
                </MenuItem>
            ))}
        </Select>
    );

    const bandFields = (
        <>
            <Grid item xs={12} sm={6}>
                {fieldBlock(
                    'Band Size',
                    textField('bandSize', 'Enter Band Size', {
                        onChange: handleNumberField('bandSize'),
                        inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
                    })
                )}
            </Grid>
            <Grid item xs={12} sm={6}>
                {fieldBlock(
                    'Number of Links / Screws',
                    textField('numberOfLinks', 'Enter number', {
                        onChange: handleNumberField('numberOfLinks'),
                        inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
                    })
                )}
            </Grid>
        </>
    );

    const renderSearchWatches = () =>
        fieldBlock(
            'SEARCH WATCHES',
            <>
                <InputBase
                    fullWidth
                    className="ai-input"
                    placeholder="SEARCH WATCHES"
                    id="autocomplete"
                    value={searchInput}
                    onChange={handleSearchChange}
                    error={Boolean(errors.selectedWatch)}
                    endAdornment={
                        <InputAdornment position="end">
                            {searchLoading ? (
                                <CircularProgress size={18} sx={{ color: GOLD }} />
                            ) : form.selectedWatch ? (
                                <IconButton size="small" onClick={handleClearWatch}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            ) : (
                                <EditIcon style={{ fontSize: 17 }} />
                            )}
                        </InputAdornment>
                    }
                />

                {showResults && !searchLoading && searchInput.trim().length > 0 && (
                    <div className="autocomplete-box">
                        <div className="watch-results">
                            <List className="searchlist inventrysearch">
                                {searchResults.length === 0 && (
                                    <ListItem>
                                        <ListItemText primary="No watches found" />
                                    </ListItem>
                                )}
                                {searchResults.map((item, idx) => (
                                    <div key={item.productid || idx}>
                                        <ListItem button onClick={() => handleSelectWatch(item)}>
                                            <ListItemIcon>
                                                <IconButton color="primary">
                                                    <img
                                                        width="45"
                                                        src={item.imagepaths?.images?.toString().split(',')[0]}
                                                        alt="Product"
                                                    />
                                                </IconButton>
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={`${item.brandname} ${item.model}`}
                                                secondary={item.family}
                                            />
                                        </ListItem>
                                        <Divider />
                                    </div>
                                ))}
                            </List>
                        </div>

                        <div
                            className="misc-watch-option"
                            onClick={() => handleWatchTypeChange({ target: { value: 'Misc Watch' } })}
                        >
                            Create New Watch
                        </div>
                    </div>
                )}

                <ErrorText>{errors.selectedWatch}</ErrorText>
            </>,
            true
        );

    const renderTechnicalDetails = () => {
        if (!form.selectedWatch || !watchDetails) return null;

        const attr = watchDetails.prodattr || {};

        const hasPurchaseRange =
            minmaxPricelist &&
            minmaxPricelist.min_inventory_cost != null &&
            minmaxPricelist.max_inventory_cost != null &&
            !(Number(minmaxPricelist.min_inventory_cost) === 0 && Number(minmaxPricelist.max_inventory_cost) === 0);

        const hasSellingRange =
            minmaxPricelist &&
            minmaxPricelist.min_invoice_cost != null &&
            minmaxPricelist.max_invoice_cost != null &&
            !(Number(minmaxPricelist.min_invoice_cost) === 0 && Number(minmaxPricelist.max_invoice_cost) === 0);

        const purchaseRange = hasPurchaseRange
            ? Number(minmaxPricelist.min_inventory_cost) === 0
                ? formatCurrency(minmaxPricelist.max_inventory_cost)
                : `${formatCurrency(minmaxPricelist.min_inventory_cost)} - ${formatCurrency(minmaxPricelist.max_inventory_cost)}`
            : "N/A";

        const sellingRange = hasSellingRange
            ? Number(minmaxPricelist.min_invoice_cost) === 0
                ? formatCurrency(minmaxPricelist.max_invoice_cost)
                : `${formatCurrency(minmaxPricelist.min_invoice_cost)} - ${formatCurrency(minmaxPricelist.max_invoice_cost)}`
            : "N/A";

        const rows = [
            ['Model Name', attr.model || watchDetails.model],
            ['Brand Name', watchDetails.brandname],
            ['Model Number', attr.reference],
            ['Case Material', attr.casematerial],
            ['Case Size', attr.casesize],
            ['Dial Color', attr.dialcolor],
            ['Band Material', attr.bandmaterial],
            ['Retail Price', retailAmount],
            ['Purchase Range', purchaseRange],
            ['Selling Range', sellingRange],
        ];

        const additionalRows = [
            ['Index Type', attr.indices],
            ['Buckle Type', attr.buckletype],
            ['Bezel', attr.bezel],
            ['Band Color', attr.bandcolor],
        ];

        return (
            <Card className="ai-tech-card">
                <CardContent>
                    <Typography className="ai-tech-card__title">TECHNICAL DETAILS</Typography>
                    <Typography component="div">
                        {rows.map(([label, value]) => (
                            <div key={label}>
                                <b style={labelStyle}>{label}</b>
                                <span style={valueStyle}>: {value || '-'}</span>
                            </div>
                        ))}

                        <Typography
                            className="additionalDetails"
                            onClick={() => setShowAdditionalDetails((v) => !v)}
                        >
                            Additional Details
                            {showAdditionalDetails ? (
                                <KeyboardArrowUpIcon style={{ fontSize: '16px' }} />
                            ) : (
                                <KeyboardArrowDownIcon style={{ fontSize: '16px' }} />
                            )}
                        </Typography>

                        {showAdditionalDetails && (
                            <CardContent style={{ padding: '5px 0px 8px 0px' }}>
                                <div style={{ marginLeft: '0px' }}>
                                    {additionalRows.map(([label, value]) => (
                                        <div key={label}>
                                            <b style={labelStyle}>{label}</b>
                                            <span style={valueStyle}>: {value || '-'}</span>
                                        </div>
                                    ))}
                                </div>
                            </CardContent>
                        )}
                    </Typography>
                </CardContent>
            </Card>
        );
    };

    const MATERIAL_CONFIG = {
        caseMaterial: { infoKey: 'caseMaterialInfo', labelKey: 'casematerial' },
        bandMaterial: { infoKey: 'brandMaterialInfo', labelKey: 'bandmaterial' },
        brand: { infoKey: 'brandInfo', labelKey: 'brandname' },
    };

    const handleMaterialChange = (name) => (e) => {
        const value = e.target.value;
        const { infoKey, labelKey } = MATERIAL_CONFIG[name];
        const all = (props[infoKey] && props[infoKey].data) || [];
        const q = value.toLowerCase();
        setForm((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
        setMaterialOptions((prev) => ({
            ...prev,
            [name]: value ? all.filter((d) => (d[labelKey] || '').toLowerCase().includes(q)) : [],
        }));
    };

    const handleMaterialSelect = (name, item) => {
        const { labelKey } = MATERIAL_CONFIG[name];
        setForm((prev) => ({ ...prev, [name]: item[labelKey] }));
        setMaterialOptions((prev) => ({ ...prev, [name]: [] }));
    };

    const renderMaterialField = (name, label, placeholder, required) => {
        const { labelKey } = MATERIAL_CONFIG[name];
        const options = materialOptions[name];
        return fieldBlock(
            label,
            <>
                <InputBase
                    fullWidth
                    className="ai-input"
                    placeholder={placeholder}
                    value={form[name]}
                    onChange={handleMaterialChange(name)}
                    onBlur={() => setMaterialOptions((prev) => ({ ...prev, [name]: [] }))}
                />
                {options.length > 0 && (
                    <List
                        className="searchlist MuiPaper-elevation1 inventrysearch"
                        style={{
                            listStyle: "none",
                            margin: 0,
                            padding: 0,
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            zIndex: 10,
                        }}
                    >
                        {options.map((item, idx) => (
                            <ListItem
                                key={idx}
                                button
                                onMouseDown={() => handleMaterialSelect(name, item)}
                                style={{ paddingTop: 4, paddingBottom: 4 }}
                            >
                                <ListItemText primary={item[labelKey]} style={{ margin: 0 }} />
                            </ListItem>
                        ))}
                    </List>
                )}
                <ErrorText>{errors[name]}</ErrorText>
            </>,
            required
        );
    };

    // NOTE: this is a function (not a constant) so it only runs at render time,
    // after renderMaterialField above has been defined.
    const renderBrandModelFields = () => (
        <>
            <Grid item xs={12}>
                {fieldBlock('Product Title', textField('inventoryTitle', 'Product Title'))}
            </Grid>
            <Grid item xs={12} sm={6}>
                {fieldBlock('Model Name', textField('modelName', 'Enter Model Name'), true)}
            </Grid>
            <Grid item xs={12} sm={6}>
                {renderMaterialField('brand', 'Brand', 'Enter Brand Name')}
            </Grid>
            <Grid item xs={12}>
                {fieldBlock('Model Number', textField('modelNumber', 'Enter Model Number'))}
            </Grid>
        </>
    );

    const renderRequestFrom = () => (
        <FormControl fullWidth className="ai-field">
            <FieldLabel required>Request From</FieldLabel>

            <div className="ai-input-icon-wrap">
                <AntdInput
                    id="RequestFrom"
                    type="text"
                    autoComplete="off"
                    className="ai-antd-input"
                    placeholder="Search dealer or source"
                    value={form.requestFrom}
                    onChange={handleRequestFromChange}
                    bordered={false}
                />

                <span className="ai-input-icon-wrap__icon">
                    {!form.requestFrom ? (
                        <SearchIcon style={{ cursor: "pointer" }} fontSize="small" />
                    ) : contactLoading ? (
                        <CircularProgress size={18} sx={{ color: GOLD }} />
                    ) : (
                        <ClearIcon
                            id="clearBtn"
                            onClick={clearRequestFrom}
                            style={{ cursor: "pointer" }}
                            fontSize="small"
                        />
                    )}
                </span>
            </div>

            {contactResults.length > 0 && form.requestFrom.length > 0 ? (
                <AntdPopover
                    visible={contactPopOver}
                    content={
                        <div style={{ height: "200px", overflow: "auto" }}>
                            {contactGroups.slice(0, 15).map((group) =>
                                group.map((el, index) => {
                                    if (index < 1) {
                                        return (
                                            <React.Fragment key={index}>
                                                {contactResults
                                                    .filter((v) => v.email == el.email)
                                                    .map((c, i) => (
                                                        <AccordionDetails key={i}>
                                                            <Typography
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => handleRequestFromSelect(c)}
                                                            >
                                                                {handleContact(c)}
                                                            </Typography>
                                                        </AccordionDetails>
                                                    ))}
                                            </React.Fragment>
                                        );
                                    }
                                    return null;
                                })
                            )}
                        </div>
                    }
                    trigger="click"
                    placement="bottomLeft"
                    onVisibleChange={(visible) => setContactPopOver(visible)}
                >
                    <div style={{ width: "100%", height: 0 }} />
                </AntdPopover>
            ) : (
                form.requestFrom.length > 2 &&
                !contactResults.length &&
                !contactLoading && (
                    <AntdPopover
                        visible={form.requestFrom.length > 2 && !contactResults.length && !contactLoading}
                        content={
                            <div style={{ overflow: "auto" }}>
                                <a
                                    className="dataItem"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        const typeData = [
                                            { id: "supplier", value: "Supplier" },
                                            { id: "memo_supplier", value: "Memo Supplier" },
                                        ];
                                        const encodedTypeData = btoa(JSON.stringify(typeData));
                                        window.open(`/contactmanagement/add?type=${encodedTypeData}`, "_blank");
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Click here to Create New Contact
                                </a>
                            </div>
                        }
                        trigger="click"
                        placement="bottomLeft"
                        overlayStyle={{ marginTop: "5px" }}
                    >
                        <div style={{ width: "100%", height: 0 }} />
                    </AntdPopover>
                )
            )}
            <ErrorText>{errors.requestFrom}</ErrorText>
        </FormControl>
    );

    const renderWatchInformation = () => {
        if (watchType === 'standard') {
            return (
                <Grid container spacing={2} className="ai-misc-grid">
                    <Grid item xs={12}>
                        {renderSearchWatches()}
                    </Grid>
                    {form.selectedWatch && (
                        <Grid item xs={12}>
                            {renderTechnicalDetails()}
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        {/* {fieldBlock('Product Title', textField('inventoryTitle', 'Product Title', { disabled: Boolean(form.selectedWatch) }))} */}
                        {fieldBlock('Product Title', textField('inventoryTitle', 'Product Title'))}
                    </Grid>
                    {bandFields}
                </Grid>
            );
        }

        if (watchType === 'misc_watch') {
            return (
                <Grid container spacing={2} className="ai-misc-grid">
                    {renderBrandModelFields()}
                    <Grid item xs={12} sm={6}>
                        {renderMaterialField('caseMaterial', 'Case Material', 'Case Material')}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {fieldBlock('Case Size', textField('caseSize', 'Enter Case Size'))}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {fieldBlock('Dial Color', textField('dialColor', 'Enter Dial Color'))}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {renderMaterialField('bandMaterial', 'Band Material', 'Band Material')}
                    </Grid>
                    {bandFields}
                </Grid>
            );
        }

        return (
            <Grid container spacing={2} className="ai-misc-grid">
                {renderBrandModelFields()}
                <Grid item xs={12}>
                    {fieldBlock('Description', textField('description', 'Description'))}
                </Grid>
                {bandFields}
            </Grid>
        );
    };

    const contentView = (
        <div className="space-1 ai-page">
            <Container maxWidth={false} className="ai-container">
                <div className="ai-topbar">
                    <div className="ai-topbar__left">
                        <div>
                            <p className="ai-topbar__title">ADD REQUEST</p>
                            <p className="ai-topbar__subtitle">
                                Submit a watch you&apos;re looking for. Add as much detail as possible.
                            </p>
                        </div>
                    </div>
                </div>

                <Grid container spacing={2} alignItems="stretch" className="watch-request-grid">
                    <Grid item xs={12} md={6}>
                        <div className="ai-col">
                            <SectionCard icon={<InfoOutlinedIcon />} title="Watch Information">
                                <FormControl fullWidth className="ai-field">
                                    <FieldLabel required>Type</FieldLabel>
                                    <Select
                                        displayEmpty
                                        variant="standard"
                                        disableUnderline
                                        className="ai-select"
                                        value={InventoryType}
                                        onChange={handleWatchTypeChange}
                                        renderValue={(value) => {
                                            if (value == null || value === "" || value === "Misc Watch") {
                                                return "Watch";
                                            }
                                            const labels = {
                                                "": "Watch",
                                                "Misc Watch": "Misc Watch",
                                                "Watch Related Accessories": "Watch Related Accessories",
                                                "Apparel": "Apparel",
                                                "Watch Parts": "Watch Parts",
                                                "Jewelry": "Jewelry",
                                                "Stones": "Stones",
                                                "Hand Bags": "Hand Bags",
                                                "Wallets": "Wallets",
                                                "Bag Related Accessories": "Bag Related Accessories",
                                                "Service Watches": "Service Watches",
                                                "Others": "Others",
                                            };
                                            return labels[value] || "Standard Watch";
                                        }}
                                    >
                                        <MenuItem value="">Watch</MenuItem>
                                        <MenuItem value="Misc Watch" style={{ display: "none" }}>Misc Watch</MenuItem>
                                        <MenuItem value="Watch Related Accessories">Watch Related Accessories</MenuItem>
                                        <MenuItem value="Apparel">Apparel</MenuItem>
                                        <MenuItem value="Watch Parts">Watch Parts</MenuItem>
                                        <MenuItem value="Jewelry">Jewelry</MenuItem>
                                        <MenuItem value="Stones">Stones</MenuItem>
                                        <MenuItem value="Hand Bags">Hand Bags</MenuItem>
                                        <MenuItem value="Wallets">Wallets</MenuItem>
                                        <MenuItem value="Bag Related Accessories">Bag Related Accessories</MenuItem>
                                        <MenuItem value="Service Watches">Service Watches</MenuItem>
                                        <MenuItem value="Others">Others</MenuItem>
                                    </Select>
                                </FormControl>
                                {renderWatchInformation()}
                            </SectionCard>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <div className="ai-col">
                            <SectionCard icon={<RequestPageOutlinedIcon />} title="Request Details">
                                <Grid container spacing={2} className="ai-misc-grid">
                                    <Grid item xs={12}>
                                        {renderRequestFrom()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth className="ai-field">
                                            <FieldLabel>Requested On</FieldLabel>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    className="ai-datepicker"
                                                    margin="normal"
                                                    id="date-picker-requested-on"
                                                    format="MM/dd/yyyy"
                                                    disableFuture
                                                    maxDateMessage=""
                                                    minDateMessage=""
                                                    invalidDateMessage=""
                                                    value={form.requestedOn || null}
                                                    onChange={handleDateField('requestedOn')}
                                                    KeyboardButtonProps={{ "aria-label": "change date" }}
                                                    placeholder="MM/DD/YYYY"
                                                    onPaste={(event) => event.preventDefault()}
                                                    // helperText={errors.requestedOn ? "Invalid date" : ""}
                                                    error={Boolean(errors.requestedOn)}
                                                />
                                            </MuiPickersUtilsProvider>
                                            <ErrorText>{errors.requestedOn}</ErrorText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {fieldBlock(
                                            'Request Notes',
                                            textField('requestNotes', 'Enter Notes', {
                                                multiline: true,
                                                large: true,
                                            })
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                                            <div style={{ flex: 1 }}>
                                                <FormControl fullWidth className="ai-field">
                                                    <FieldLabel>Target Min Price ($)</FieldLabel>
                                                    <InputBase
                                                        fullWidth
                                                        className="ai-input"
                                                        placeholder="Enter Min Amount"
                                                        value={formatWithCommas(form.preferredBudget)}
                                                        onChange={handlePriceField('preferredBudget')}
                                                        error={Boolean(errors.preferredBudgetMax)}
                                                        inputProps={{ inputMode: 'decimal', 'aria-label': 'Minimum target price' }}
                                                    />
                                                </FormControl>
                                            </div>

                                            <div style={{ width: 24, flexShrink: 0 }}>
                                                <FormControl fullWidth className="ai-field">
                                                    <FieldLabel>
                                                        <span style={{ visibility: 'hidden' }}></span>
                                                    </FieldLabel>
                                                    <span
                                                        style={{
                                                            fontSize: "24px",
                                                            fontWeight: "300",
                                                            marginTop: "18px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        -
                                                    </span>
                                                </FormControl>
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <FormControl fullWidth className="ai-field">
                                                    <FieldLabel>Target Max Price ($)</FieldLabel>
                                                    <InputBase
                                                        fullWidth
                                                        className="ai-input"
                                                        placeholder="Enter Max Amount"
                                                        value={formatWithCommas(form.preferredBudgetMax)}
                                                        onChange={handlePriceField('preferredBudgetMax')}
                                                        error={Boolean(errors.preferredBudgetMax)}
                                                        inputProps={{ inputMode: 'decimal', 'aria-label': 'Maximum target price' }}
                                                    />
                                                </FormControl>
                                            </div>
                                        </div>
                                        <ErrorText>{errors.preferredBudgetMax}</ErrorText>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth className="ai-field">
                                            <FieldLabel>Target Date</FieldLabel>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    className="ai-datepicker"
                                                    margin="normal"
                                                    id="date-picker-target-date"
                                                    format="MM/dd/yyyy"
                                                    value={form.targetDate || null}
                                                    onChange={handleDateField('targetDate')}
                                                    KeyboardButtonProps={{ "aria-label": "change date" }}
                                                    placeholder="MM/DD/YYYY"
                                                    onPaste={(event) => event.preventDefault()}
                                                    disablePast
                                                    maxDateMessage=""
                                                    minDateMessage=""
                                                    invalidDateMessage=""
                                                    // helperText={errors.targetDate ? "Invalid date" : ""}
                                                    error={Boolean(errors.targetDate)}
                                                />
                                            </MuiPickersUtilsProvider>
                                            <ErrorText>{errors.targetDate}</ErrorText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </SectionCard>
                        </div>
                    </Grid>
                </Grid>

                {/* <Box sx={{ mt: 2 }}>
                    <SectionCard
                        icon={<CloudUploadOutlinedIcon />}
                        title="Reference Image / Video"
                    >
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <div className="ai-uploads__col-title">
                                    Images <span className="ai-field-label"></span>
                                </div>
                                <UploadZone
                                    accept="image/jpeg,image/png"
                                    hint="JPG, PNG"
                                    icon={<InsertDriveFileOutlinedIcon />}
                                    files={images}
                                    onAdd={(f) => {
                                        setImages((prev) => [...prev, ...f]);
                                        if (errors.images) setErrors((p) => ({ ...p, images: undefined }));
                                    }}
                                    onRemove={(i) => setImages((prev) => prev.filter((_, idx) => idx !== i))}
                                />
                                <ErrorText>{errors.images}</ErrorText>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="ai-uploads__col-title">Videos</div>
                                <UploadZone
                                    accept="video/mp4,video/quicktime"
                                    hint="MP4, MOV"
                                    icon={<VideocamOutlinedIcon />}
                                    files={videos}
                                    onAdd={(f) => setVideos((prev) => [...prev, ...f])}
                                    onRemove={(i) => setVideos((prev) => prev.filter((_, idx) => idx !== i))}
                                />
                            </Grid>
                        </Grid>
                    </SectionCard>
                </Box> */}

                <div className="ai-bottombar">
                    <Button className="ai-btn ai-btn--ghost" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        className="ai-btn ai-btn--primary"
                        disabled={saving}
                        onClick={handleSave}
                    >
                        Save Request
                        {saving && (
                            <CircularProgress size={18} sx={{ color: '#fff' }} />
                        )}
                    </Button>
                </div>
            </Container>
        </div>
    );

    return <ContentWrapper contentView={contentView} />;
};

function mapStateToProps({ individualBrowseWatchesInfo, auth, dealer, browseWatchesInfo }) {
    return {
        individualBrowseWatchesInfo: individualBrowseWatchesInfo.individualBrowseWatchesInfo,
        currentUser: auth.currentUser,
        autocompleteProducts: dealer.autoCompleteProducts,
        brandInfo: browseWatchesInfo.brandInfo,
        caseMaterialInfo: browseWatchesInfo.caseMaterialInfo,
        brandMaterialInfo: browseWatchesInfo.brandMaterialInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            individualBrowseWatch,
            searchProducts,
            brandList,
            caseMaterial,
            brandMaterial,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchRequestPage);
